// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "custom/Cards/InfoCards/SimpleInfoCard";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Information() {
  return (
    <MKBox component="section" py={6} mt={6}>
      <Container>
        <Grid container spacing={3} item xs={12} lg={8} mx="auto">
          <MKTypography variant="h3" mb={7}>
            ¿Qué es la Prueba de Penetración Web 3.0?
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La Prueba de Penetración Web 3.0 es un enfoque integral y sistemático para evaluar la seguridad de aplicaciones descentralizadas (dApps), contratos inteligentes y redes blockchain. Implica pruebas y análisis rigurosos para identificar vulnerabilidades y debilidades que podrían ser explotadas por actores malintencionados en el ecosistema Web 3.0.
          </MKTypography>
          <MKTypography variant="h3" mb={7} mt={7}>
            Aspectos Clave de la Prueba de Penetración Web 3.0
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="code"
                title="Auditorías de Contratos Inteligentes"
                description="Examen exhaustivo de contratos inteligentes para identificar vulnerabilidades, fallos lógicos y posibles exploits. Esto asegura la integridad y seguridad de las transacciones basadas en blockchain."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="settings"
                title="Pruebas de Aplicaciones Descentralizadas (dApp)"
                description="Evaluación de dApps para descubrir debilidades de seguridad en su código, arquitectura e interacciones con la red blockchain."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="network_check"
                title="Seguridad de la Red Blockchain"
                description="Evaluación de la seguridad de la red blockchain subyacente, incluidos los mecanismos de consenso, la comunicación entre nodos y los posibles vectores de ataque."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="description"
                title="Informes Detallados"
                description="Las organizaciones reciben informes completos que describen las vulnerabilidades identificadas, su impacto potencial y recomendaciones para la mitigación y remediación específicas para aplicaciones Web 3.0."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="security"
                title="Escenarios de Ataque Realistas"
                description="Los evaluadores emplean técnicas y tácticas similares a las utilizadas por posibles atacantes, emulando escenarios de ataque del mundo real para descubrir vulnerabilidades y debilidades."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            ¿Por qué Importa la Prueba de Penetración Web 3.0?
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="lock"
                title="Protección de Activos Digitales"
                description="Salvaguarda los activos digitales, como criptomonedas y tokens, asegurando su seguridad y previniendo el acceso no autorizado o el robo."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="folder_off"
                title="Mitigación de Brechas de Seguridad"
                description="Al identificar y abordar vulnerabilidades, la prueba de penetración Web 3.0 ayuda a prevenir brechas de seguridad y las consecuencias legales, financieras y de reputación asociadas."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="person_check"
                title="Confianza y Adopción del Usuario"
                description="Las aplicaciones Web 3.0 seguras fomentan la confianza del usuario, mejorando la adopción de usuarios y la experiencia general del usuario."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="gavel"
                title="Cumplimiento y Normas"
                description="Muchas industrias y organismos reguladores exigen evaluaciones de seguridad rigurosas para las aplicaciones Web 3.0 para cumplir con los estándares de cumplimiento."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            El Rol de la Prueba de Penetración Web 3.0 en la Ciberseguridad
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La Prueba de Penetración Web 3.0 es una piedra angular de una estrategia integral de ciberseguridad en una era donde las aplicaciones descentralizadas y la tecnología blockchain son cada vez más prevalentes. Asegura la seguridad de las aplicaciones Web 3.0, protegiendo los activos digitales y la confianza del usuario en un mundo digital cada vez más descentralizado. Al adoptar la prueba de penetración Web 3.0, las organizaciones pueden mantener una postura de seguridad robusta, asegurando que sus aplicaciones permanezcan resilientes ante amenazas y vulnerabilidades en evolución.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;